<template>
  <table id="table" border="1" cellpadding="0" cellspacing="0" style="width: 100%">
    <caption id="tablePrintText">
      <div style="font-weight: 600; letter-spacing: 0px">{{ hotelInfo.name }}</div>
      <div style="font-weight: 600">自助核销统计报表</div>
      <div style="display: flex; justify-content: space-between">
        <div>
          <span style="font-weight: 600">营业日期:{{ listQuery.businessDate }}</span>
        </div>
        <div>
          <span style="font-weight: 600">打印人:{{ employee.name }}</span>
          <span style="font-weight: 600">打印时间:{{ currentTime }}</span>
        </div>
      </div>
    </caption>
    <thead>
      <tr v-if="exportShow">
        <th :colspan="tabelTitel.length">{{ hotelInfo.name }}</th>
      </tr>
      <tr v-if="exportShow">
        <th :colspan="tabelTitel.length">自助核销统计报表</th>
      </tr>
      <tr v-if="exportShow">
        <th :colspan="tabelTitel.length / 2">
          <div style="font-weight: 600; text-align: left">
            <template>营业日期:{{ listQuery.businessDate }}</template>
          </div>
        </th>
        <th style="text-align: right" :colspan="(tabelTitel.length + 1) / 2">打印人:{{ employee.name }} 打印时间:{{ currentTime }}</th>
      </tr>
      <tr>
        <th style="position: sticky; top: 0; background-color: #fff" v-for="th in tabelTitel" :key="th.code">
          {{ th.chinese_desc }}
        </th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(row, index) in mergedTableData">
        <!-- 普通数据行 -->
        <tr v-if="!row._isSummary" :key="row.id || index">
          <td v-for="col in tabelTitel" :key="col.code">{{ row[col.code] }}</td>
        </tr>
        <!-- 团队小计行 -->
        <tr v-else :key="row.groupName" class="group-summary">
          <td v-for="col in tabelTitel" :key="col.code">
            <template v-if="col.code === 'groupName'"></template>
            <template v-else-if="sumFields.includes(col.code)">{{ row[col.code] }}</template>
            <template v-else></template>
          </td>
        </tr>
      </template>
      <tr v-if="sumsTotal && sumsTotal.length" class="total-summary">
        <td v-for="(sum, idx) in sumsTotal" :key="idx">{{ sum }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import DateUtils from '@/utils/DateUtils';
export default {
  props: {
    tabelTitel: {
      type: Array,
      default: [],
    },
    tabelList: {
      type: Array,
      default: [],
    },
    sumsTotal: {
      type: Array,
      default: [],
    },
    groupSums: {
      type: Array,
      default: [],
    },
    listQuery: {
      type: Object,
    },
    exportShow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sumFields() {
      return ['total2', 'quantity', 'payTotal', 'writeOffCount', 'writeOffTotal', 'writeOffPayTotal', 'unWriteOffCount'];
    },
    // 生成带团队小计行的完整表格数据
    mergedTableData() {
      if (!this.tabelList.length) return [];

      const result = [];
      // 按团队分组，同时记录团队出现的顺序
      const groupOrder = [];
      const groups = {};
      this.tabelList.forEach(item => {
        const group = item.groupName || '无团队';
        if (!groups[group]) {
          groups[group] = [];
          groupOrder.push(group);
        }
        groups[group].push(item);
      });

      // 构建团队小计映射表，便于快速获取
      const groupSumMap = {};
      this.groupSums.forEach(group => {
        groupSumMap[group.groupName] = group;
      });

      // 按团队顺序输出数据行 + 小计行
      groupOrder.forEach(groupName => {
        // 添加该团队的所有数据行
        result.push(...groups[groupName]);
        // 添加小计行
        const groupSum = groupSumMap[groupName];
        if (groupSum) {
          result.push({ _isSummary: true, groupName, ...groupSum });
        }
      });
      return result;
    },
  },
  data() {
    return {
      employee: JSON.parse(localStorage.getItem('user')),
      currentTime: DateUtils.formatDate(new Date(), 'yyyy-MM-dd hh:mm'), //当前的时间
      hotelInfo: JSON.parse(localStorage.getItem('hotel')),
      queryShiftValue: '',
    };
  },
  mounted() {},
};
</script>
